/**
 * Виджет «Погода» — заглушка (карточка поля v3, вкладка «Обзор», PR-B).
 *
 * Метео-интеграции ещё нет. По эталону founder (2026-07-11) показываем 4 ячейки
 * «скоро» + пояснение, чтобы место под будущие метрики читалось как осознанный
 * «скоро», а не сломанный виджет. Достойный вид без выдуманных цифр —
 * никаких фейковых осадков/температур.
 */
import { CloudSun } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Stack } from '@/components/ui/stack';
import { TileGrid } from '@/components/ui/tile-grid';

const CELLS = [
  'Накопленные осадки',
  'Средняя температура',
  'Сумма активных температур',
  'Прогноз на 10 дней',
];

export function WeatherWidget() {
  return (
    <Card>
      <CardHeader className="p-4 pb-3">
        <CardTitle className="flex items-center gap-2 leading-6">
          <CloudSun className="h-4 w-4 text-muted-foreground" />
          Погода
        </CardTitle>
      </CardHeader>
      {/* Плитки — TileGrid: равная высота в ряду и gap-3, как у «Рельефа»;
          границы плиток обоих виджетов совпадают по вертикали. */}
      <CardContent className="p-4 pt-0">
        <Stack gap={3}>
          <TileGrid cols={2}>
            {CELLS.map((label) => (
              <div key={label} className="rounded-lg bg-muted/60 p-3">
                <div className="text-base font-semibold leading-6 text-muted-foreground">
                  скоро
                </div>
                <div className="text-xs text-muted-foreground">{label}</div>
              </div>
            ))}
          </TileGrid>
          <p className="text-xs text-muted-foreground">
            Метео-интеграция подключается — данные появятся здесь.
          </p>
        </Stack>
      </CardContent>
    </Card>
  );
}

export default WeatherWidget;
